import moment from 'moment';
import React from 'react';
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import loadable from "@loadable/component";
const DatePicker = loadable(() => import("./datepicker"));

const InputField = ({ fieldClass, labelClass, type, name, value, required, placeholder, handlechange, pattern, label, grpmd, onFocus, min, startDate, setStartDate, mainClass, defaultValue }) => {
    React.useEffect(() => {
        var input = document.getElementById('validationtelephone');
        if (input) {
            input.onkeydown = function (e) {
                let k = e.which;
                /* numeric inputs can come from the keypad or the numeric row at the top */
                if (
                    (k < 48 || k > 57) && // top-row digits
                    (k < 96 || k > 105) && // numpad digits
                    ![8, 9, 32, 37, 38, 39, 40, 46, 107, 109, 187, 189, 187, 189, 57, 48, 16].includes(k)
                ) {
                    e.preventDefault();
                    return false;
                }
                if (e.target.value.length > 20 && (k != 8) && (k != 46)) {
                    e.preventDefault()
                    return false;
                }
            };
        }
        var input1 = document.getElementById('validationtelephone1');
        if (input1) {
            input1.onkeydown = function (e) {
                let k = e.which;
                /* numeric inputs can come from the keypad or the numeric row at the top */
                if (
                    (k < 48 || k > 57) && // top-row digits
                    (k < 96 || k > 105) && // numpad digits
                    ![8, 9, 32, 37, 38, 39, 40, 46, 107, 109, 187, 189, 187, 189, 57, 48, 16].includes(k)
                ) {
                    e.preventDefault();
                    return false;
                }
                if (e.target.value.length > 20 && (k != 8) && (k != 46)) {
                    e.preventDefault()
                    return false;
                }
            };
        }
        var nameInput = document.getElementById('validationname');
        if (nameInput) {
            nameInput.onkeydown = function (e) {
                let k = e.which;
                if ((k > 48 && k < 57) && (k != 8)) {
                    e.preventDefault();
                    return false;
                }
            };
        }
        var nameInput1 = document.getElementById('validationname1');
        if (nameInput1) {
            nameInput1.onkeydown = function (e) {
                let k = e.which;
                if ((k > 48 && k < 57) && (k != 8)) {
                    e.preventDefault();
                    return false;
                }
            };
        }
    }, []);
    return (
        <Form.Group as={Col} md={grpmd} controlId={"validation" + name} className={"form-wrap " + mainClass}>
            {label ? <Form.Label className={labelClass}>{label}{required ? '*' : ''}</Form.Label> : ''}
            {(type == "date" || type == "time") ?
                <DatePicker
                    {...{ fieldClass, labelClass, type, name, value, required, placeholder, handlechange, pattern, label, grpmd, onFocus, min, startDate, setStartDate, mainClass, defaultValue }}
                />
                :
                <Form.Control
                    className={fieldClass}
                    required={required}
                    type={type}
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    onChange={handlechange}
                    // defaultValue={defaultValue}
                    pattern={pattern}
                    onFocus={onFocus}
                    min={min}
                />
            }
        </Form.Group>
    );
}

export default InputField;